import { render } from "./Leave_Applications.vue?vue&type=template&id=3515b060"
import script from "./Leave_Applications.vue?vue&type=script&lang=js"
export * from "./Leave_Applications.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__